// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"5d17038d","683":"fe978ada","805":"c7ea22d8"}[chunkId] + ".chunk.css";
};